import { render } from "./LayoutContainer.vue?vue&type=template&id=c11c84d6"
import script from "./LayoutContainer.vue?vue&type=script&lang=js"
export * from "./LayoutContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__